import { render, staticRenderFns } from "./ProjShare.vue?vue&type=template&id=3ac93839&"
import script from "./ProjShare.vue?vue&type=script&lang=js&"
export * from "./ProjShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports